import * as _ from "lodash";
import * as angular from "angular";
import { CanvassStatus } from "../../models/canvass-status.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";

let MigrateCanvassStatus = {
    selector: "vcMigrateCanvassStatus",
    templateUrl:
        "/angular/components/canvass-status/migrate-canvass-status.component.html",
    bindings: {
        selectedStatus: "=?",
    },
    controller: class MigrateCanvassStatusController {
        // * bindings for typescript compiler *
        public selectedStatus?: any;
        // ************************************

        private dataProvider: CanvassStatusDataProvider;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        public isLeaderView: boolean;
        public saving = false;
        public status: CanvassStatus;
        public canvassStatuses: CanvassStatus[];
        public numCanvasses: number;

        constructor(
            __app_type: string,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils
        ) {
            this.dataProvider = CanvassStatusDataProvider;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.isLeaderView = __app_type == "LEADER";

            this.dataProvider.walkCanvassStatuses().then((statuses) => {
                this.canvassStatuses = statuses;
            });
        }

        $onInit() {
            this.status = _.cloneDeep(this.selectedStatus);

            if (!this.isLeaderView) {
                this.dataProvider.canvassCount(this.status).then((count) => {
                    this.numCanvasses = count;
                });
            }
        }

        migrateStatus(
            oldStatus: CanvassStatus,
            newStatus: CanvassStatus
        ): void {
            this.saving = true;
            this.dataProvider.migrate(oldStatus, newStatus).then(
                (status) => {
                    // The leader view has no count: it spans every campaign.
                    this.toast.success(
                        this.isLeaderView
                            ? "Changed the status of interactions from " +
                                  oldStatus.name +
                                  " to " +
                                  newStatus.name
                            : "Changed the status of " +
                                  this.numCanvasses +
                                  " interactions to " +
                                  newStatus.name
                    );
                    this.dialog.hide(status);
                },
                (error) => {
                    console.log(error);
                }
            );
        }

        ok(status: CanvassStatus, newStatus: CanvassStatus): void {
            this.migrateStatus(status, newStatus);
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("canvassStatus")
    .component(MigrateCanvassStatus.selector, MigrateCanvassStatus);
